import React, { useState } from 'react'
import { Box, Tab, Tabs, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import SuppliersTab from './SuppliersTab'
import PitsYardsTab from './PitsYardsTab'
import OfferingsTab from './OfferingsTab'
import MaterialsTab from './MaterialsTab'
import GradationsTab from './GradationsTab'

const useStyles = makeStyles((theme) => ({
  root: { width: '100%', minHeight: '100vh', backgroundColor: '#fff' },
  header: { padding: theme.spacing(2, 3, 0), display: 'flex', alignItems: 'center', gap: theme.spacing(2) },
  tabs: { borderBottom: `1px solid ${theme.palette.divider}`, marginBottom: theme.spacing(1) }
}))

export default function AggregateDashboardPage () {
  const classes = useStyles()
  const [tab, setTab] = useState(0)

  return (
    <div className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h5">Aggregate Dashboard</Typography>
      </Box>
      <Tabs value={tab} onChange={(e, v) => setTab(v)} className={classes.tabs} indicatorColor="primary" textColor="primary">
        <Tab label="Suppliers" />
        <Tab label="Pits & Yards" />
        <Tab label="Offerings" />
        <Tab label="Materials" />
        <Tab label="Gradations" />
        <Tab label="Sync" disabled />
        <Tab label="Review" disabled />
      </Tabs>
      {tab === 0 && <SuppliersTab />}
      {tab === 1 && <PitsYardsTab />}
      {tab === 2 && <OfferingsTab />}
      {tab === 3 && <MaterialsTab />}
      {tab === 4 && <GradationsTab />}
      {tab >= 5 && <Box p={3}><Typography color="textSecondary">Coming in next phase</Typography></Box>}
    </div>
  )
}
